import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { BrowserService } from '../../../services/browser.service';
import { StateService } from '../../../services/state.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-preview-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ButtonDirective],
  templateUrl: './preview-banner.component.html',
  styleUrl: './preview-banner.component.scss',
})
export class PreviewBannerComponent {
  private state = inject(StateService);
  private browserService = inject(BrowserService);
  previewMode = signal(!!this.state.galleryPreviewMode);
  gallery = input.required<GalleryDto>();
  correctPicflowUrl = this.browserService.getCorrectPicflowUrl();
}
